module.exports = __webpack_public_path__ + "static/media/remise-dao.153dd0b9.png";